import CenterCenterVerticalContainer from "../../components/layout/CenterCenterVerticalContainer";
import MainPageComponent from "../../components/page/MainPageComponent";

function UserMainView() {

    let breadcrumbPath = [
        { value: 'Inicio', href: '/' },
        { value: 'Usuario', href: '' }
    ];

    return (
        <div>
            <MainPageComponent requireAuthentication={true} path={breadcrumbPath} >
                <CenterCenterVerticalContainer>
                        <h1>MAIN</h1>
                </CenterCenterVerticalContainer>
            </MainPageComponent>
        </div>
    );
}

export default UserMainView;